module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("List of illustrations")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("An Alouette helicopter arriving at a landmine scene; Nyamapanda, 1976. Note the Internal Affairs Lee Enfield .303 in the foreground. (Ron Rink)")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("Paddy Allen at Mukumbura, 1975. (Author’s collection)")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("An India Troop (red and blue) lanyard and Support Unit shoulder flash.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("India Troop lads at Wedza TTL, 1977. (Kiaran Allen)")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("Kiaran Allen and a troop sergeant at Diti TTL, 1977. (Kiaran Allen)")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("The author at Diti TTL, 1977; the Nulli Hills are in the background. Note the starlight scope hanging off the neck. (Kiaran Allen)")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("A burnt-out store; Chibi TTL, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("The Paddy Allen memorial; Warren Hills, Salisbury.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("The Wilson Banda memorial; Warren Hills, Salisbury.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("Ron Rink sitting on a keep wall; Nyamapanda, 1976. (Ron Rink)")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("Mick Busby, Billy Pring and the author at Plumtree, 1978. (Ray Hughes)")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("Ray Hughes receiving his wings, 1980. (Dave and Eileen Hughes)")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("The Police Commissioner’s letter.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("Medal parade, 1978; the author receives the PCG wearing a hat lent to Joan Stapa by the Honourable P.K. van der Byl.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("Phil Smith: the epitome of the warrior. (Fiona Smith)")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("Skip in Rushinga with a UANC detachment, 1979. (Skip Dolega)")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("The author in plaster after the leg wound, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("The Shangaan Army lads lining up for the photo, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("Some captured weapons and ammunition by the Shangaans, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("The author working in farm security in the Marandellas District during the 1980 elections.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_s1"
  }, [_vm._v("Farm workers ready to vote with Colin and Jennifer, 1980.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e0c5dae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Illustrations.vue
// module id = 75
// module chunks = 0